import { render, staticRenderFns } from "./SetPhoto.vue?vue&type=template&id=67ba9b80&scoped=true"
import script from "./SetPhoto.vue?vue&type=script&lang=js"
export * from "./SetPhoto.vue?vue&type=script&lang=js"
import style0 from "./SetPhoto.vue?vue&type=style&index=0&id=67ba9b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ba9b80",
  null
  
)

export default component.exports